import { Directive, ElementRef, Input } from '@angular/core';
import { Banner } from '@services/element-position-service/element-position.service.types';

@Directive({
  selector: '[appTrackable]',
  standalone: false,
})
export class ElementTrackableDirective {
  @Input() bannerName: string;
  @Input() carousel: boolean = false;
  @Input() pageName: string;
  @Input() eventData?: { [key: string]: string | string[] };
  @Input() channels?: string[];

  constructor(public element: ElementRef) {}

  isValid(): boolean {
    if (!this.bannerName) return false;
    const nativeElement = this.element.nativeElement;
    return this.carousel || (nativeElement.childElementCount > 0 && nativeElement.offsetHeight > 0);
  }

  toBanner(): Banner {
    return {
      name: this.bannerName,
      element: this.element,
      pageName: this.pageName,
      carousel: this.carousel,
      eventData: this.eventData,
      channels: this.channels
    };
  }
}
